/** @format */

import { FileSearchOutlined, ReloadOutlined } from "@ant-design/icons";
import { Alert, Button, Space, Tag } from "antd";
import { findValuesFromArray } from "utils/helper";
import moment from "moment";
import "moment/locale/id";
import { ButtonTableApproval, ButtonTableDetail } from "components/Button";

export const ColumnsTableListMadrasahVerifikasi = (
  refProvinsi: any,
  refKabkota: any,
  tmpJenisPenerimaBOS: any,
  handleAfterDokumen: (record: any) => void,
) => [
  {
    title: "NSM",
    dataIndex: "nsmMadrasah",
    key: "nsmMadrasah",
  },
  {
    title: "Nama",
    dataIndex: "namaMadrasah",
    key: "namaMadrasah",
  },
  {
    title: "Jenjang",
    dataIndex: "jenjangMadrasah",
    key: "jenjangMadrasah",
    render: (jenjangMadrasah) => (
      <div className="uppercase">{jenjangMadrasah}</div>
    ),
  },
  {
    title: "Provinsi",
    dataIndex: "kodeProvinsi",
    key: "kodeProvinsi",
    render: (kodeProvinsi) => {
      let namaProvinsi: any =
        refProvinsi.find((item) => item.kode === kodeProvinsi) || null;
      return namaProvinsi?.nama;
    },
  },
  {
    title: "Kab / Kota",
    dataIndex: "kodeKabkota",
    key: "kodeKabkota",
    render: (kodeKabkota) => {
      let namaKabkota: any =
        refKabkota.find((item) => item.kode === kodeKabkota) || null;
      return namaKabkota?.nama;
    },
  },
  {
    title: `Jenis Penerima BOS`,
    key: "penerimaBos",
    dataIndex: "penerimaBos",
    render: (penerimaBos) =>
      findValuesFromArray(tmpJenisPenerimaBOS, "kode", penerimaBos, "name"),
  },
  {
    title: "Status",
    dataIndex: "statusValidasi",
    key: "statusValidasi",
    render: (statusValidasi) => {
      return (
        <Tag color={(statusValidasi === 1 && "#008000") || "#ffca27"}>
          {(statusValidasi === 1 && "Disetujui") || "Belum Disetujui"}
        </Tag>
      );
    },
  },
  {
    title: "Aksi",
    key: "aksi",
    render: (record) => {
      return (
        <Space>
          <Button
            icon={<FileSearchOutlined />}
            onClick={() => handleAfterDokumen(record)}>
            Lihat Dokumen
          </Button>
        </Space>
      );
    },
  },
];

export const ColumnsDokumenMadrasah = (
  fileList: any,
  activeTabKey: any,
  dataMadrasah: any,
  showAlert: boolean,
  listLap: any,
  handleAfterApproval: (record: any) => void,
  handleAction: (kode: any) => void,
  handleDoubleDokumen: (record: any, doubleDok: any) => void,
  resolveFileDok: (record: any) => any,
  resolveDoubleDok: (record: any) => any[],
) => {
  const getFile = (record: any) => resolveFileDok(record);

  // Duplikat dicari lintas batch pengajuan (kode_id bisa berbeda antar batch
  // untuk dokumen yang sama), bukan exact match kode_id batch aktif saja.
  const getDoubleDok = (record: any) => resolveDoubleDok(record) || [];

  return [
    {
      title: "Nama",
      dataIndex: "nama",
      key: "nama",
    },
    {
      title: "Nama File",
      key: "namaFile",
      render: (record) => {
        const file = getFile(record);
        return file?.namaDok || "";
      },
    },
    {
      title: "Tanggal Upload",
      key: "tanggalUpload",
      render: (record) => {
        const file = getFile(record);
        return file?.created_at
          ? moment(file.created_at).format("DD MMM YYYY")
          : "";
      },
    },
    {
      title: "Tanggal Verifikasi",
      key: "tanggalVerifikasi",
      render: (record) => {
        const file = getFile(record);
        return file?.tanggal_verifikasi_dokumen
          ? moment(file.tanggal_verifikasi_dokumen).format("DD MMM YYYY")
          : "";
      },
    },
    {
      title: "Keterangan",
      key: "keterangan",
      render: (record) => {
        const file = getFile(record);

        if (record.kode === "docRkam" && showAlert) {
          return (
            <div className="mb-4">
              <Alert
                className="mb-4"
                message={
                  <>
                    Rencana belanja definitif belum sesuai dengan rencana
                    pendapatan.
                  </>
                }
                type="error"
                showIcon
              />
            </div>
          );
        }

        return file?.keterangan || "";
      },
    },
    {
      title: "Status",
      key: "statusValidasi",
      render: (record) => {
        const file = getFile(record);

        if (listLap.includes(record?.kode)) return;
        if (!file) return <Tag>Dokumen Kosong</Tag>;

        const status = file?.statusValidasi?.toString();

        const color =
          status === "2" ? "red" : status === "1" ? "#008000" : "#ffca27";

        const label =
          status === "2"
            ? "DiTolak"
            : status === "1"
              ? "Disetujui"
              : "Belum Disetujui";

        if (activeTabKey && !listLap.includes(record?.kode)) {
          return <Tag color={color}>{label}</Tag>;
        }

        return <Tag color={color}>{label}</Tag>;
      },
    },
    {
      title: "Aksi",
      key: "aksi",
      render: (record) => {
        const file = getFile(record);
        const doubleDok = getDoubleDok(record);

        return (
          <Space>
            {file && (
              <ButtonTableApproval
                tooltips="Konfirmasi Dokumen"
                onClick={() => handleAfterApproval(record)}
              />
            )}

            {fileList?.length !== 0 && listLap.includes(record?.kode) && (
              <Button
                icon={<ReloadOutlined />}
                onClick={() => handleAction(record?.kode)}>
                Lihat Data
              </Button>
            )}

            {!listLap.includes(record?.kode) && doubleDok.length >= 2 && (
              <ButtonTableDetail
                onClick={() => handleDoubleDokumen(record, doubleDok)}
                tooltips="Dokumen Double"
              />
            )}
          </Space>
        );
      },
    },
  ];
};
